import React, { useState, useEffect } from 'react';
import Checkbox from '../../../../components/Checkbox';
import { A } from 'hookrouter';
import { AddAttendance, RemoveAttendance } from '../../../../components/exl/requests/LectureRequests';
import '../../../../styles/pages/exl-course-details.scss'
import InfoSection from '../../course-details/course-details-body/info-section';
import OnHoverTooltip from '../../../../../src/components/tables/shared/OnHoverTooltip';
import { useTranslation } from 'react-i18next';
import { LECTURE_ATTENDANCE_NO_PARTICIPANTS, LECTURE_ATTENDANCE_USE_MODAL_TOOLTIP } from '../../../../i18n/keyConstants';


export default function LectureAttendance({ lecture }) {
    const { t } = useTranslation('lectureAttendance');

    if (lecture?.course.bookings?.length < 1) {
        return (
            <div style={{ color: "grey" }}>{t(LECTURE_ATTENDANCE_NO_PARTICIPANTS)}</div>
        )
    }

    return (
        <div>
            {lecture.course.bookings.map((booking) => (
                <div className={"d-flex card ml-auto p-2 mb-2 list-card"} key={booking.id}>
                    <Attendance lecture={lecture} booking={booking} />
                </div>
            ))}
        </div>
    )
}
const Attendance = ({ booking, lecture }) => {
    const [isInAttendance, setIsInAttendance] = useState();
    const [attendanceId, setAttendanceId] = useState();
    const { t } = useTranslation('lectureAttendance');

    useEffect(() => {
        checkAttendance();
    }, []);

    function checkAttendance() {
        lecture.attendances.forEach((attendance) => {
            if (attendance.bookingId === booking.id) {
                setIsInAttendance(true)
                setAttendanceId(attendance.id);
            }
        })
    }

    function setAttendance(isChecked) {
        if (isChecked) {
            AddAttendance(booking.id, lecture.id).then((response) => {
                setAttendanceId(response.data.id);
            })
        }
        else {
            RemoveAttendance(attendanceId);
        }
    }

    return (
        <div className='d-flex justify-content-between align-content-center attendance-list-row'>
            <div className=''>
                {booking.coaEmpId ?
                    <A href={`/employee/${booking.coaEmpId}/info`}>
                        {booking.coaEmpName}
                    </A> :
                    <p style={{ marginBottom: "10px" }}>{booking.coaEmpName}</p>
                }
            </div>
            <div className='' style={{ paddingLeft: '10px' }}>
                <OnHoverTooltip
                    labelClassNames='d-flex margin-none'
                    tooltipType='dark'
                    tooltipPlace='right'
                    tooltipEffect='solid'
                >
                    <input
                        type='checkbox'
                        defaultChecked={isInAttendance}
                        onChange={(e) => setAttendance(e.target.checked)}
                        disabled={true}
                        style={{ height: '20px', width: '20px', marginBottom: '15px' }}
                    />
                    <span style={{ width: 125 }}>
                        {t(LECTURE_ATTENDANCE_USE_MODAL_TOOLTIP)}
                    </span>
                </OnHoverTooltip>
            </div>
        </div>
    )
};
